<template>
    <div class="box1">
        <div class="handle-box-search order">
            <el-row type="flex" justify="start" class="row">
                <div>
                    <div class="ordTitle"><i class="el-icon-setting"></i>设置查询条件</div>
                </div>
            </el-row>
            <el-row type="flex" justify="start" align="middle" class="row">
                <slot name="order_year"></slot>
            </el-row>
            <el-row type="flex" justify="start" align="middle" class="row">
                <span class="title">查询订单按:</span>
                <el-select v-model="submit_data.order_time" placeholder="请选择模式" style="width: 350px; margin-right: 20px" clearable>
                    <el-option label="下单时间" value="order_time_stamp"></el-option>
                    <el-option label="服务完成时间" value="end_time_stamp"></el-option>
                    <el-option label="订单支付时间" value="pay_time_stamp"></el-option>
                </el-select>
            </el-row>
            <el-row align="middle" type="flex" justify="start" class="row">
                <span class="title">订单模式:</span>
                <el-select
                    v-model="value_mode_code"
                    placeholder="请选择模式"
                    @visible-change="modeVisibleChange"
                    @change="modeChange"
                    clearable
                    style="width: 350px; margin-right: 20px position: relative"
                >
                    <el-option
                        v-for="item in options_mode_code"
                        :key="item.value"
                        :label="item.order_mode.name"
                        :value="item.order_mode.order_mode_code"
                    >
                    </el-option>

                    <el-pagination
                        class="pagination"
                        layout="prev, pager, next"
                        :total="selectPages_data.count"
                        :page-size="mode_options_data.limit"
                        @current-change="selectPages_function"
                        :current-page="mode_options_data.page"
                    />
                </el-select>
                <span class="remark">选择订单模式</span>
            </el-row>
            <!-- 订单导出和历史订单导出订单类型的title值不同，所以用插槽 -->
            <el-row type="flex" justify="start" align="middle" class="row">
                <slot name="order_type"></slot>
            </el-row>

            <el-row align="middle" type="flex" justify="start" class="row">
                <span class="title">订单渠道:</span>
                <el-select v-model="submit_data.order_source" placeholder="请选择渠道" clearable style="width: 350px">
                    <el-option :label="item.name" :value="item.order_source" v-for="(item, index) in partnerList" :key="index"> </el-option>
                </el-select>
                <span class="remark">选择订单渠道来源</span>
            </el-row>
            <!-- 订单导出和历史订单导出查询时间范围不同，所以用插槽 -->
            <el-row type="flex" justify="start" align="middle" class="row">
                <slot name="his_type"></slot>
            </el-row>
            <el-row align="middle" type="flex" justify="start" class="row">
                <span class="title">指定客户订单:</span>
                <el-input v-model="submit_data.consumer_phone" style="width: 350px" maxlength="11"></el-input>
                <span class="remark">输入客户手机号</span>
            </el-row>

            <el-row align="middle" type="flex" justify="start" class="row">
                <span class="title">导出指定司机订单:</span>
                <el-input v-model="submit_data.driver_phone" style="width: 350px" maxlength="11"></el-input>
                <span class="remark">输入司机手机号</span>
            </el-row>
            <el-row type="flex" justify="start" class="row">
                <div>
                    <div class="ordTitle">
                        <i class="el-icon-s-operation"></i>配置附加导出项<span class="remark"
                            >勾选后会在原有基础上增加选中的字段导出所需数据</span
                        >
                    </div>
                </div>
            </el-row>
            <el-row type="flex" justify="start" class="row">
                <div>
                    <el-checkbox-group v-model="other_items" class="order-export-checkbox order-export">
                        <el-checkbox v-for="item in other_item" :label="item.title" border :key="item.title">{{ item.name }}</el-checkbox>
                    </el-checkbox-group>
                </div>
            </el-row>

            <div style="width: 500px; margin: 10px auto" v-if="progress_show">
                <el-progress :percentage="progress_data"></el-progress>
                <i class="el-icon-loading"></i>
                正在导出...
            </div>
            <div v-else style="display: flex; justify-content: center"></div>
            <el-row type="flex" justify="start" style="display: flex; justify-content: center">
                <!-- <el-button type="primary" @click="toExport">导出订单信息</el-button> -->
                <el-button type="primary" @click="toJSON">导出订单信息</el-button>
            </el-row>
        </div>

        <!-- <orderPwd :isShow="pwd_isShow" @passwordSuccess="passwordSuccess"></orderPwd> -->
        <orderPwd :isShow="pwd_isShow" :data="submit_data" @passwordSuccess="passwordSuccess"></orderPwd>
    </div>
</template>

<script>
import axios from 'axios';
import { config } from '@/utils/config.js';
import bus from '@/components/common/bus.js'; //配置
import orderPwd from './orderPwd.vue';
import { formFilter } from '@/utils/form'; // 引入表单验证模块
var _this;
export default {
    name: 'orderCommonExport',
    components: {
        orderPwd
    },
    props: {
        isShow: Boolean,
        history: ''
    },

    data() {
        return {
            type: '',
            submit_data: {
                page: 1,
                fixed_array: '',
                order_time: '',
                type: '',
                year: '',
                order_mode_code: '',
                export_password: '',
                driver_phone: '',
                consumer_phone: '',

                order_source: ''
            },
            other_item: [],
            other_items: [],
            options_mode_code: [],
            pwd_isShow: false,
            his_isShow: false,

            value_mode_code: '',
            mode_options_data: {
                page: 1,
                limit: 5,
                status: ''
            },
            selectPages_data: [],

            submit_rules: {
                year: {
                    placeholder: '年份',
                    rules: {
                        required: false,
                        message: '年份不能为空',
                        regulation: 'egt_str',
                        rulesData: 0
                    }
                },
                order_time: {
                    placeholder: '查询订单按',
                    rules: {
                        required: true,
                        message: '查询订单按不能为空',
                        regulation: 'egt_str',
                        rulesData: 0
                    }
                },

                type: {
                    placeholder: '订单类型',
                    rules: {
                        required: true,
                        message: '订单类型不能为空',
                        regulation: 'egt_str',
                        rulesData: 0
                    }
                },
                fixed_array: {
                    placeholder: '查询时间',
                    rules: {
                        required: true,
                        message: '查询时间不能为空',
                        regulation: 'egt_str',
                        rulesData: 0
                    }
                }
            },

            partnerList: [],

            excelData: [],

            excelHead: [],

            progress_show: false,
            progress_data: 0
        };
    },
    created() {
        _this = this;
        _this.orderExtendItem();

        // axios.defaults.baseURL = config.axios_normalURL; //请求normal url
        _this
            .$post('/order/getPartnerList', {}, {}, 'normal')
            .then((res) => {
                _this.partnerList = res.data;
                // axios.defaults.baseURL = config.axios_baseURL; //请求normal url
            })
            .catch((err) => {});
        // axios.defaults.baseURL = config.axios_baseURL; //请求normal url

        bus.$on('btnStatus', (msg) => {
            _this.progress_show = msg;
        });
    },

    methods: {
        selectPages_function(val) {
            _this.mode_options_data.page = val;

            _this.orderModeList();
        },
        modeVisibleChange() {
            if (_this.options_mode_code.length == 0) {
                _this.orderModeList();
            }
        },
        orderModeList() {
            // 请求公司管理接口获取公司唯一编码
            _this
                .$post('/order/orderModeLists', _this.mode_options_data)
                .then((res) => {
                    _this.selectPages_data = res;
                    _this.options_mode_code = res.data;
                })
                .catch((err) => {});
        },
        modeChange(val) {
            _this.submit_data.order_mode_code = val;
        },

        orderHis() {


            this.$router.push('/historyOrderExport');
        },
        toJSON() {

            if (_this.history == 'history') {

                _this.submit_rules.year.rules.required = true;
                let startStr = _this.submit_data.fixed_array.slice(12, 16);
                let endStr = _this.submit_data.fixed_array.slice(34, 38);

                if (Number(_this.submit_data.year) != startStr || Number(_this.submit_data.year) != endStr) {
                    this.$message.error('查询时间的年份和您选择的年份不一致，请修改一致后查询');
                    return;
                }
            }

            _this.submit_data.other_item = JSON.stringify(_this.other_items);


            if (!formFilter(this, _this.submit_data, _this.submit_rules)) {
                return formFilter(this, _this.submit_data, _this.submit_rules);
                // 如果表单验证通过，则打开密码框，否则不打开
            }

            _this.pwd_isShow = !_this.pwd_isShow;
        },
        passwordSuccess(val) {

            _this.submit_data.export_password = val;

            _this.getExcelData();

            _this.progress_show = true;
        },

        getExcelData() {
            _this
                .$post('/order/getOrderVisitCSV', _this.submit_data, _this.submit_rules)
                .then((res) => {
                    if (this.$route.path == '/orderExport' || this.$route.path == '/historyOrderExport') {
                        let change_item = JSON.parse(_this.submit_data.other_item);

                        for (let i = 0; i < res.data.list.length; i++) {


                            _this.excelData.push({
                                order_time: res.data.list[i].order_time.YmdHis, //下单时间
                                end_time: res.data.list[i].end_time.YmdHis, //完成时间
                                pay_time: res.data.list[i].pay_time.YmdHis, //支付时间
                                driver_name: res.data.list[i].driver_real_name, //司机姓名
                                driver_phone: res.data.list[i].driver_phone, //司机电话
                                // consumer_phone: res.data.list[i].consumer_phone, // 根据角色的权限控制这个是否显示，转移到附加导出项里面了
                                is_new_visit: res.data.list[i].is_new_visit.alias, //新老用户
                                start_name: res.data.list[i].start_name, //起点
                                end_name: res.data.list[i].end_name, //终点
                                platform: res.data.list[i].platform.alias, //平台来源
                                amount: res.data.list[i].amount, //订单实际金额
                                finish_amount: res.data.list[i].finish_amount, //客户实际支付金额
                                admin_name: res.data.list[i].admin_name, //订单来源
                                is_group_pay: res.data.list[i].is_group_pay, //是否为集团
                                pay_mode: res.data.list[i].pay_mode.alias, //支付方式
                                pay_channel: res.data.list[i].pay_channel.alias, //支付通道
                                coupon_code: res.data.list[i].coupon_code, //优惠券编码
                                coupon_amount: res.data.list[i].coupon_amount, //优惠券金额
                                coupon_bear_price: res.data.list[i].coupon_bear_price, //优惠券司机承担金额
                                order_type: res.data.list[i].order_type, //订单支付状态
                                driver_amount: res.data.list[i].driver_amount, //司机实际收到金额
                                billno: res.data.list[i].billno, //订单编号
                                insurance: res.data.list[i].insurance, //服务费
                                order_code: res.data.list[i].order_code, //订单唯一编码值
                                price_amount: res.data.list[i].price_amount, //现金券使用金额
                                order_source: res.data.list[i].order_source, //订单渠道
                                remarks: res.data.list[i].remarks, //备注
                                assign_time: res.data.list[i].assign_time.YmdHis, //派单时间
                                take_time: res.data.list[i].take_time.YmdHis, //接单时间
                                go_way_time: res.data.list[i].go_way_time.YmdHis, //前往预约地时间
                                arrive_time: res.data.list[i].arrive_time.YmdHis, //到达预约地时间
                                start_time: res.data.list[i].start_time.YmdHis, //前往目的地时间
                                end_time: res.data.list[i].end_time.YmdHis, //到达目的地时间
                                subsidiary_money: res.data.list[i].subsidiary_money, //分公司扣款
                                order_mode_name: res.data.list[i].order_mode.name, //订单模式
                                type: _this.type, //订单类型
                            });

                            // 遍历已选择附加项数据
                            for (let j = 0; j < change_item.length; j++) {
                                // 在excelData中添加对象------>
                                //  {
                                //     已选择数据：接口中已选择数据对应的值
                                //  }

                                // _this.excelData[i][change_item[j]] = res.data.list[i][change_item[j]]; （50条以后不显示use_time的值,因为list最多只有50条）

                                //  _this.excelData[每次请求接口返回数据条数 x 页数 - 每次请求接口返回数据条数 + 此次返回数据的index(下标)] ----->当前遍历到的数据在数据中数中的index(下标)
                                _this.excelData[res.data.limit * res.data.page - res.data.limit + i][change_item[j]] =
                                    res.data.list[i][change_item[j]];
                            }


                        }

                        if (res.data.page * res.data.limit < res.data.count) {
                            _this.submit_data.page = res.data.page + 1;

                            _this.progress_data = Math.floor(((res.data.page * res.data.limit) / res.data.count) * 100);

                            _this.getExcelData();
                        } else {


                            // 将数据导出execl
                            _this.exportData();

                            _this.submit_data.page = 1;
                            _this.orderExtendItem();

                            // 清空数据
                            _this.excelData = [];
                            _this.closeDialog();

                            _this.progress_show = false;
                            _this.progress_data = 0;
                        }
                    } else {
                        _this.progress_show = false;
                        _this.progress_data = 0;
                    }
                })
                .catch((err) => {});
        },
        closeDialog() {
            _this.type = '';
            _this.other_item = [];
            _this.other_items = [];

            _this.value_mode_code = '';

            _this.submit_data = {
                page: 1,
                fixed_array: '',
                order_time: '',
                type: '',
                year: '',
                order_mode_code: '',
                export_password: '',
                driver_phone: '',
                consumer_phone: '',

                order_source: ''
            };
            this.$emit('changeType');
            this.$emit('changeTime');
            this.$emit('changeYear');
        },

        // 导出excel方法
        exportData() {



            const { export_json_to_excel } = require('@/vendor/Export2Excel');

            let tHeader = [
                '下单时间',
                '完成时间',
                '支付时间',
                '司机姓名',
                '司机电话',
                // '乘客电话',

                '新老用户',
                '起点',
                '终点',
                '平台来源',
                '订单实际金额',
                '客户实际支付金额',
                '订单来源',

                '是否为集团',

                '支付方式',
                '支付通道',
                '优惠券编码',
                '优惠券金额',
                '优惠券司机承担金额',
                '订单支付状态',
                '司机实际收到金额',

                '订单编号',
                '服务费',
                '订单唯一编码值',
                '现金券使用金额',

                '订单渠道',
                '备注',
                '派单时间',
                '接单时间',
                '前往预约地时间',
                '到达预约地时间',
                '前往目的地时间',
                '到达目的地时间',

                '分公司扣款',
                '订单模式',
                '订单类型'
            ];

            let filterVal = [
                'order_time',
                'end_time',
                'pay_time',
                'driver_name',
                'driver_phone',
                // 'consumer_phone',

                'is_new_visit',
                'start_name',
                'end_name',
                'platform',
                'amount',
                'finish_amount',
                'admin_name',

                'is_group_pay',

                'pay_mode',
                'pay_channel',
                'coupon_code',
                'coupon_amount',
                'coupon_bear_price',
                'order_type',
                'driver_amount',

                'billno',
                'insurance',

                'order_code',

                'price_amount',

                'order_source',
                'remarks',
                'assign_time',
                'take_time',
                'go_way_time',

                'arrive_time',
                'start_time',
                'end_time',
                'subsidiary_money',
                'order_mode_name',
                'type'
            ];

            // 已选择附加项数组
            let change_item = JSON.parse(_this.submit_data.other_item);

            // 遍历全部数据
            for (let i = 0; i < _this.other_item.length; i++) {
                // 遍历已选数据
                for (let j = 0; j < change_item.length; j++) {

                    if (_this.other_item[i].title == change_item[j]) {
                        // 筛选已选项在全部数据中的title和name

                        tHeader.push(_this.other_item[i].name);

                        filterVal.push(_this.other_item[i].title);
                    }
                }
            }

            const list = this.excelData;
            const data = this.formatJson(filterVal, list);
            export_json_to_excel(tHeader, data, 'fileName');
        },

        formatJson(filterVal, jsonData) {
            return jsonData.map((v) => filterVal.map((j) => v[j]));
        },

        // 获取订单导出选择项接口
        orderExtendItem() {
            // axios.defaults.baseURL = config.axios_normalURL; //请求normal url
            _this
                .$post('/system/orderExtendItem', {}, {}, 'normal')
                .then((res) => {
                    // 将请求的数据存放到表格数据数组中
                    _this.other_item = res.data;
                    // axios.defaults.baseURL = config.axios_baseURL; //请求base url
                })
                .catch((err) => {});
            // axios.defaults.baseURL = config.axios_baseURL; //请求base url
        }
    }
};
</script>

<style scoped>
.box1 {
    height: 100% !important;
    background-color: #fff !important;
}

.remark {
    font-size: 14px;
    margin-left: 10px;
    color: #c2c4c9;
}

.handle-box-search.order .title {
    display: inline-block;
    width: 120px;
    font-size: 14px;
    text-align: right;
    margin-right: 5px;
    color: #747474;
}
.handle-box-search.order .row {
    margin: 30px 0;
}
</style>

<style>
.order-export-checkbox .el-checkbox__input {
    display: none !important;
}
.order-export-checkbox .el-checkbox.is-checked {
    background-color: #05c0aa13 !important;
}
.order-export.order-export-checkbox .el-checkbox {
    margin: 5px 10px !important;
    padding: 5px 10px !important;
}
.order-export.order-export-checkbox .el-checkbox .el-checkbox__label {
    padding: 0 !important;
}
</style>
